import React from "react"
import styled from "styled-components"

const Background = styled.div`
    max-width: 100%;
    width: ${(props) => (props.big ? "300px" : "100px")};
    height: 40px;
    border-radius: 8px;
    border: solid 1px ${(props) => props.borderColor};
    color: ${(props) => props.textColor};
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${(props) => props.bgColor};
    cursor: pointer;
`

function Button(props) {
    return (
        <Background
            borderColor={props.borderColor}
            big={props.big}
            textColor={props.textColor}
            bgColor={props.bgColor}
            onClick={() => props.onClick()}
        >
            {props.children}
        </Background>
    )
}

export default Button
